export default "__VITE_ASSET__CeSSYmix__"